
const Banner = () => {
  return (
    <div className="container banner">
        <h3 className="heading">summer vacation</h3>
        <h1 className="desc">Nomad nation</h1>
        <button className="read-more">read more</button>
    </div>
  )
}

export default Banner